import React, { FC } from 'react'

import { Typography } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import { capitalizeFirstLetter } from '../../helpers'
import { CoachOverviewActiveLabelBox } from './styled'

interface AppUserActiveStatusProps {
	readonly status: 'active' | 'inactive'
	readonly wrapperSx?: object
	readonly renderCustomData?: (
		status: 'active' | 'inactive'
	) => React.ReactNode
}

const AppUserActiveStatus: FC<AppUserActiveStatusProps> = ({
	status,
	wrapperSx,
	renderCustomData,
}: AppUserActiveStatusProps) => {
	return (
		<CoachOverviewActiveLabelBox sx={wrapperSx}>
			{!renderCustomData && (
				<>
					{status === 'active' ? (
						<CheckCircleIcon color={'success'} fontSize={'small'} />
					) : (
						<CancelIcon color={'error'} fontSize={'small'} />
					)}

					<Typography ml={'.1563rem'} color={'#65676f'}>
						{capitalizeFirstLetter(status)}
					</Typography>
				</>
			)}

			{renderCustomData && renderCustomData(status)}
		</CoachOverviewActiveLabelBox>
	)
}

export default AppUserActiveStatus
